<template>
  <div class="page-wecom-seminar-entry"></div>
</template>
<script>
import { getRequest } from 'utils/string';
import { postOauth, getEId, gotoActivity } from 'utils/wecom/seminar';
export default {
  name: 'Entry',
  computed: {
    userId() {
      return getRequest()?.user_id || '';
    },
    pageOrigin() {
      return window.location.origin;
    },
    middleUrl() {
      return `/wecom/seminar/middle/eid/${this.userId}`;
    },
    returnUrl() {
      return `${this.pageOrigin}${this.middleUrl}`;
    },
    failUrl() {
      return `/wecom/seminar/error/eid-1/${this.userId}`;
    }
  },
  created() {
    this.$loading.show();
    getEId().then(res => {
      if (res?.data) {
        gotoActivity(this.userId);
      } else {
        postOauth(this.returnUrl, this.failUrl);
      }
    });
    this.$loading.hide();
  }
};
</script>
